<template>
  <v-layout fill-height column>
    <div class="question" v-html="ques[0]"></div>
    <v-layout class="answer" align-center justify-center>
      <div class="input-time-group">
        <input type="number" v-model="min" class="input" placeholder="00" :maxlength="2" :readonly="isDisabledTime" min="0">
        <span class="txt">분</span>
        <input type="number" v-model="sec" class="input" placeholder="00" :maxlength="2" :readonly="isDisabledTime" min="0">
        <span class="txt">초</span>
      </div>
    </v-layout>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import FooterBtnsNext from "@/components/btns/FooterBtnsNext"
import store from '@/store'

export default {
  components: {
    FooterBtnsNext,
  },
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq"],
  data: () => ({
    min: '00',
    sec: '',
    disabledNext: true,
    free: 'N',
    cmplt: false,
    ques: [],
    replyArr: [],
    replyObjArr: [],
    userReplyNo: [0],
    userReply: [],
    timeType: ''
  }),
  computed: {
    isDisabledTime () {
     return this.cmplt || this.timeType === '02'
    }
  },
  watch: {
    min() {
      if (this.min.search('-') >= 0) {
        console.log("-----min : ", this.min)
        this.min = "0"
      }
      // 숫자 글자수 제한
      if (this.min.length > 2) {
        this.min = this.min.slice(0, 2);
      }
      this.isDisabledNext()
    },
    sec() {
      if (this.sec.search('-') >= 0) {
        console.log("-----sec : ", this.sec)
        this.sec = "0"
      }

      // 숫자 글자수 제한
      if (this.sec.length > 2) {
        this.sec = this.sec.slice(0, 2);
      }
      this.isDisabledNext()
    },
  },
  created() {
    this.getUnitDetailUse()
  },
  methods: {
    async getUnitDetailUse() {
      // 유닛 사용 번호
      // console.log('unitUseNo : ', this.unitUseNo)
      // 유닛상세 사용 번호
      // console.log('unitDtlUseNo : ', this.unitDtlUseNo)
      // console.log('unitDtlUseNo : ', this.unitDtlUseNo[this.current-1])
      // console.log('unitDtlPageSeq : ', this.unitDtlPageSeq)
      // console.log('unitDtlPageSeq : ', this.unitDtlPageSeq[this.current-1])

      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = (this.cmpltYn === 'true' || this.cmpltYn === true) ? true : false
      // this.cmplt = true
      // console.log('this.free : ', this.free)
      // console.log('this.cmplt : ', this.cmplt)

      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl, i) => {

              // 질문 셋팅
              this.ques.push(quesEl.ques)
              this.timeType = quesEl.timeType
              if (quesEl.timeType == '02') {
                this.min = quesEl.timeSet.substr(0, 2)
                this.sec = quesEl.timeSet.substr(2, 2)
              }

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                // 렌더링 때문에 답변따로 먼저 저장 후 객체도 저장
                // this.replyArr.push(replyEl.reply)
                this.replyObjArr.push(replyEl)
              });

              // 유저 답변 셋팅
              quesEl.memberUnitDtlReplyList.forEach((userReplyEl, j) => {
                this.userReplyNo[i + j] = userReplyEl.memberUnitDtlReplyUseNo
                this.min = userReplyEl.reply.substr(0, 2)
                this.sec = userReplyEl.reply.substr(2, 2)
              });
              // console.log('this.min : ', this.min)
              // console.log('this.sec : ', this.sec)
            });

          } else {
            console.log(res.msg)
            // this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          // this.answer = [];
        })
        .finally(() => {
        })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 시간 앞자리에 '0' 채워서 저장
        let time = this.min.padStart(2, '0') + this.sec.padStart(2, '0')

        // 시간 답변
        let replyObj = this.replyObjArr[0]
        this.userReply[0] = {
          unitId: replyObj.unitId,
          sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

          memberUnitDtlReplyUseNo: this.userReplyNo[0],
          // unitUseNo: replyObj.unitUseNo,
          unitNo: replyObj.unitNo,
          // unitDtlUseNo: replyObj.unitDtlUseNo,
          unitDtlNo: replyObj.unitDtlNo,
          // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
          unitDtlQuesNo: replyObj.unitDtlQuesNo,
          // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
          unitDtlReplyNo: replyObj.unitDtlReplyNo,
          userKey: this.$store.state.auth.authUser.userKey,
          reply: time,
          // score: score/10,
          freeYn: this.free
        }

        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
          .then(res => {
            if (res.success) {
              setTimeout(() => this.$emit('next'), 500); // 저장한 이후
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
      } else {
        this.$emit('next')
      }
    },
    isDisabledNext() {
      let time = this.min.padStart(2, '0') + this.sec.padStart(2, '0')
      // console.log("time : ", time)

      if (this.min.length <= 0 || this.sec.length <= 0 || time == '0000') {
        this.disabledNext = true
      } else {
        this.disabledNext = false
      }
    },
  }
}
</script>
